import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-textarea',
  imports: [CommonModule,FormsModule,ReactiveFormsModule,NgbModule],
  templateUrl: './textarea.component.html',
  styleUrl: './textarea.component.scss'
})
export class TextareaComponent implements OnInit, OnChanges {
    ngOnChanges(changes: SimpleChanges): void {
      if (changes['existingValue'] && changes['existingValue'].currentValue !== undefined) {
        this.value = changes['existingValue'].currentValue;
      }

      if (this.checkValidation === true && !this.value) {
        this.showRequiredError = true;
      }
    }

  ngOnInit(): void {
    if (this.keyRequired === true) {
      setTimeout(() => {
        this.requiredKey.emit({id:this.id,required:this.keyRequired})
      }, 300);
    }
      if (this.existingValue) {
    this.value = this.existingValue;
    this.selecteditem.emit({
    id: this.id,
    value: this.value
  });
  }
  }
  @Output() requiredKey = new EventEmitter<{id:string,required:boolean}>()
  @Input() placeholder: string = '';
  @Input() header: string = '';
  @Input() keyRequired = false;
  @Input() pattern?: string;
  @Input() existingValue : string = ''

  @Input() id :string = ""
  @Output() selecteditem = new EventEmitter<{id:string,value:string}>()
  @Input() checkValidation :boolean = false
  @Input() readonly:boolean = false;
  @Input() disabled:boolean = false;
  value: string = '';
  showRequiredError = false;
  showPatternError = false;

  onInputChange(event: Event) {
  const input = event.target as HTMLTextAreaElement;
  this.value = input.value.trim();

  // Required validation
  this.showRequiredError = this.keyRequired && !this.value;

  // Pattern validation (only if a regex is provided AND value exists)
  if (this.pattern && this.pattern !== '' && this.value) {
    const regex = new RegExp(this.pattern);
    this.showPatternError = !regex.test(this.value);
  } else {
    this.showPatternError = false;
  }
}

onSubmitValue(event: Event) {
  const inputElement = event.target as HTMLInputElement;
  this.value = inputElement.value.trim();

  // Reset errors
  this.showRequiredError = false;
  this.showPatternError = false;

  // Validation 1: required
  if (this.keyRequired && !this.value) {
    this.showRequiredError = true;
    return;
  }

  // Validation 2: pattern (only if provided)
  if (this.pattern && this.pattern !== '' && this.value) {
    const regex = new RegExp(this.pattern);
    if (!regex.test(this.value)) {
      this.showPatternError = true;
      return;
    }
  }

  // ✅ If all good → emit
  this.selecteditem.emit({
    id: this.id,
    value: this.value
  });
}

}
